import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { CustomField } from "~/components/CustomField";
import { KANBAN_COLUMN_HEADER_ITEM_COUNT } from "~/constants/testIDs";
export const KanbanColumnHeaderDisplay = /*#__PURE__*/ memo((param)=>{
    let { id, label, itemCount, color } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex h-8 items-center",
        children: [
            /*#__PURE__*/ _jsx(CustomField, {
                field: {
                    color: {
                        name: color || "transparent"
                    },
                    id,
                    value: label
                },
                size: "medium"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ml-2 text-12 text-grey-8",
                "data-testid": KANBAN_COLUMN_HEADER_ITEM_COUNT,
                children: itemCount
            })
        ]
    });
});
KanbanColumnHeaderDisplay.displayName = "KanbanColumnHeaderDisplay";
